import { useCallback } from "react";

import { apiClient } from "../../lib/api";

import type { ApiPayload } from "common/classes/api-payload";

export function useResetPassword(): (email: string, resetToken: string, newPassword: string) => Promise<ApiPayload> {
  const resetPassword = useCallback(
    async (email: string, resetToken: string, newPassword: string): Promise<ApiPayload> => {
      const response = await apiClient.resetPassword(email, resetToken, newPassword);

      if (!response.success) {
        throw new Error(response.message ?? `unexpectedError`);
      }

      return response;
    },
    [],
  );

  return resetPassword;
}
